import React from 'react';
import { heroBg } from '../media/images';
export default function GenerateMetaTags({
  title,
  description,
  image,
  type,
  url
}) {
  let metaTags = [];

  title = title || 'Bildeler til din bil - Du får det du trenger hos oss';
  image = image || heroBg;

  if (title) {
    metaTags = metaTags.concat([
      <title key="title">{title} | Bil1Din</title>,
      <meta key="twitter-title" name="twitter:title" content={title} />,
      <meta key="og-title" property="og:title" content={title} />
    ]);
  }

  if (description) {
    metaTags = metaTags.concat([
      <meta key="description" name="description" content={description} />,
      <meta
        key="twitter-description"
        name="twitter:description"
        content={description}
      />,
      <meta
        key="og-description"
        property="og:description"
        content={description}
      />
    ]);
  }

  if (image) {
    metaTags = metaTags.concat([
      <meta key="twitter-image" name="twitter:image" content={image} />,
      <meta key="og-image" property="og:image" content={image} />
    ]);
  }

  if (type) {
    metaTags = metaTags.concat([
      <meta key="og-type" property="og:type" content={type} />
    ]);
  }

  if (url) {
    metaTags = metaTags.concat([
      <meta key="og-url" property="og:url" content={url} />
    ]);
  }

  return metaTags;
}
